import { Col, Row, Space } from 'antd';
import { NextPage } from 'next';
import { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { InfoCards } from '../../components/home/info-cards';
import { InfoSection } from '../../components/home/info-section';
import { QuestionAndAnswer } from '../../components/home/question-and-answer';
import { UnverifiedAccountAlert } from '../../components/home/unverified-account-alert';
import { UpcomingAppointments } from '../../components/home/upcoming-appointments';
import { HeaderProps, PageWrapper } from '../../components/page-wrapper';
import { SmartSearch } from '../../components/smart-search';
import { buildFullName, getSex } from '../../helpers/formatters';
import { useCurrentUser } from '../../helpers/utils';
import { ScreenSizeContext } from '../_app';
import styles from './home.module.scss';

const Home: NextPage = () => {
  const { formatMessage } = useIntl();

  const { currentUser } = useCurrentUser();

  const [mobile, setMobile] = useState<boolean>(false);

  const { isMobile } = useContext(ScreenSizeContext);

  useEffect(() => {
    setMobile(isMobile);
  }, [isMobile]);

  return (
    <PageWrapper backgroundImage={'/background.jpg'} headerProps={headerProps}>
      <UnverifiedAccountAlert />
      <Space style={{ width: '100%' }} direction={'vertical'} size={mobile ? 20 : 64}>
        {!mobile && (
          <Row>
            <Col span={24}>
              {currentUser && (
                <div className={styles.greeting}>
                  {formatMessage(
                    { id: 'home.hello' },
                    {
                      name: buildFullName(
                        currentUser.name,
                        formatMessage({ id: getSex(currentUser?.sex) }),
                      ),
                    },
                  )}
                </div>
              )}
              <span className={styles.appointmentTitle}>
                {formatMessage({ id: 'home.find-your-appointment' })}
              </span>
              <div className={styles.smartSearchWrapper}>
                <SmartSearch />
              </div>
            </Col>
          </Row>
        )}
        <Row>
          <Col span={24}>
            <InfoCards />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <UpcomingAppointments />
          </Col>
        </Row>
        <InfoSection />
        {/*<Row>*/}
        {/*  <Col span={24}>*/}
        {/*    <App />*/}
        {/*  </Col>*/}
        {/*</Row>*/}

        <Row>
          <Col span={24}>
            <QuestionAndAnswer />
          </Col>
        </Row>

        {/*<Row>
          <Col span={24}>
            <TrustedPartners />
          </Col>
        </Row>*/}
      </Space>
    </PageWrapper>
  );
};

const headerProps: HeaderProps = {
  title: 'Homepage',
  keywords: ['avelios medical', 'krankenhaus'],
};

export default Home;
